<template></template>

<script>
import { mapState, mapMutations } from "vuex";
import { inApp, brower } from "@/common/wxJs/wx-util";

export default {
  name: "wxShare",
  data() {
    return {
      id: "",
      meta: [],
      useApp: null,
    };
  },
  computed: {
    ...mapState(["jsUrl", "appJson", "isMyApp", "isPreview"]),
  },
  mounted() {
    this.useApp = new inApp();
    this.id = this.$appCommonH.getDataByKey("id");

    // //为移动端设置首次分享数据
    // let meta = this.$route.meta;
    // if(meta.meta){
    //
    //     this.meta = JSON.parse(JSON.stringify(this.$route.meta.meta));
    //
    //     if(this.appJson.shareInfo){
    //         this.meta.push(...this.appJson.shareInfo)
    //     }
    //
    //     //二次分享
    //     this.doShare();
    //
    // }
  },
  methods: {
    initShare() {
      console.log("初始化分享信息...");
      if (this.$route.meta.meta) {
        this.meta = JSON.parse(JSON.stringify(this.$route.meta.meta));
      }

      if (this.appJson.shareInfo) {
        this.meta.push(...this.appJson.shareInfo);
      }

      //二次分享
      this.doShare();
    },
    /**
     * 二次分享
     */
    doShare() {
      let url = "";
      var obj = this.$appCommonH.getShareParams(this.meta);
      obj.desc = obj.desc || "我正在参与报名活动，快来参与吧！";
      obj.imgUrl = obj.imgUrl;
      if (brower.version.ios) {
        url = this.jsUrl.split("#")[0];
      }
      this.useApp.initShare(obj, url, () => {
        console.log("设置自定义分享信息成功回调");
      });

      let _vue = this;

      try {
        if (window.xhCloud && typeof window.xhCloud.setShare === "function") {
          window.xhCloud.setShare({
            title: obj.title,
            description: obj.desc,
            imageUrl: obj.imgUrl,
            url: obj.link,
          });
        }
        if (typeof GLOBAL_CONFIG !== "undefined") {
          // app中配置了为app提供分享信息方法

          // 设置分享信息
          Object.defineProperty(GLOBAL_CONFIG, "shareInfo", {
            get: function () {
              let target = {
                shareTitle: obj.title,
                description: obj.desc,
                shareImage: obj.imgUrl,
                shareLink: obj.link,
              };
              return target;
            },
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/wxShare.vue